import React from 'react';
import { styles } from './MarketplaceSellerCallout.css';
import { Link } from '../../PlatformFunctionality';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';

export type MarketplaceSellerCalloutProps = {
  sellerName: string;
  marketplaceCallout?: string;
  sellerHref?: string;
  className?: string;
  testId?: string;
};

export const MarketplaceSellerCallout = ({
  sellerName,
  sellerHref,
  className,
  marketplaceCallout = 'Sold and sent by',
  testId = 'marketplace-seller_callout',
}: MarketplaceSellerCalloutProps) => {
  return (
    <p className={classNames(styles.marketplaceSellerCallout, className)} data-testid={testId}>
      <strong>JB Hi-Fi Marketplace: </strong>
      {marketplaceCallout}&nbsp;
      <wbr />
      {React.createElement(
        sellerHref ? Link : 'span',
        { className: styles.sellerName, href: sellerHref as string },
        sellerName
      )}
    </p>
  );
};
